module.exports = {"title":"Delete Flexpass","description":"The “Sale End Time” for patrons and box office will be set to the past so sales are no longer available. At any time, you can open sales again by accessing the Flex Pass in Past Events and simply editing the “Sale End Time” to a date/time in the future.","stopSales":"Stop Sales","cancel":"Cancel"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/ConfirmDeleteFlexpassModal/locales/fr.json
// module id = 1309
// module chunks = 0